import { CzechHolidays } from 'czech-holidays';

export function listAllFreeDaysInBetween(_from: Date | null | string, _to: Date | null | string): string[] {
    if (!_from || !_to) return [];
    const from = new Date(_from);
    const to = new Date(_to);

    let holidays = CzechHolidays(from.getFullYear());
    if (from.getFullYear() != to.getFullYear()) {
        holidays = holidays.concat(...CzechHolidays(to.getFullYear()));
    }
    const allDays = [];
    while (true) {
        if (
            from.getDay() === 0 || from.getDay() === 6
            || !!holidays.find((it) => it.d == from.getDate() && (it.m - 1) == from.getMonth())
        ) {
            allDays.push(`${from.getDate()}.${from.getMonth() + 1}`);
        }

        from.setDate(from.getDate() + 1);
        if (from.getDate() == to.getDate() && from.getMonth() == to.getMonth()) break;
    }
    return allDays;
}

export function formatMinutesToHHmm(_minutes?: string | number | null): string {
    if (_minutes === null || _minutes === undefined) return '';
    let min = _minutes;
    if (typeof _minutes === 'string') {
        min = _minutes.split(',').reduce((acc, it) => Number(it) + acc, 0);
    }

    const minutes = Number(min);
    const hours = Math.floor(minutes / 60);
    const mins = Math.round(minutes % 60);

    return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
}
